export default [
  {
    path: '/pledge-2022/index',
    name: 'index',
    component: () => import('@/views/pledge-2022'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2022/pledgeall',
    name: 'pledgeall',
    component: () => import('@/views/pledge-2022/pledgeall'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2022/pledgeform',
    name: 'pledgeform',
    component: () => import('@/views/pledge-2022/pledgeform'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2022/pledgepersonal',
    name: 'pledgepersonal',
    component: () => import('@/views/pledge-2022/pledgepersonal'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2022/pledgeshare/:id',
    name: 'pledgeshare',
    component: () => import('@/views/pledge-2022/pledgeshare'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2022/pledgevoice',
    name: 'pledgevoice',
    component: () => import('@/views/pledge-2022/pledgevoice'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2022/pledgelist/:province_id',
    name: 'pledgelist',
    component: () => import('@/views/pledge-2022/pledgelist'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2022/pledgelist',
    name: 'pledgelist',
    component: () => import('@/views/pledge-2022/pledgelist'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2022/pledgecard/:id',
    name: 'pledgecard',
    component: () => import('@/views/pledge-2022/pledgecard'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2022/pledgeupload',
    name: 'pledgeupload',
    component: () => import('@/views/pledge-2022/pledgeupload'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2022/lottery',
    name: 'lottery',
    component: () => import('@/views/pledge-2022/lottery'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2022/lotteryRecord',
    name: 'lotteryRecord',
    component: () => import('@/views/pledge-2022/lotteryRecord'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  },
  {  
    path: '/pledge-2022/pledgedetail/:id',
    name: 'pledgedetail',
    component: () => import('@/views/pledge-2022/pledgedetail'),
    meta: {
      title: '2022高考誓师大会-高考直通车'
    }
  }
  
]
